module.exports = __webpack_public_path__ + "img/IMG_5002_L_Wood_MockedUp.ed365aeb.jpg";